export default __webpack_public_path__ + "static/media/machine-picture.457d7566.png";